import React from 'react'
import { ChatControl } from '../TopRow/ChatControl/ChatControl'
import NotificationsControl from '../TopRow/NotificationsControl/NotificationsControl'
import { WalletComponent } from '../rightSide/walletComponent/WalletComponent'
import SearchButton from './Search.button'
import { DesktopContainer, WalletSection, RightSection, ControlsGroup } from './AppTop.styled'
import { AuthViewProps } from './AppTop.interface'
import { AuthSection } from './AppTop.auth'
import CollapseIcon from '../icons/collapse'
import { Link } from 'react-router-dom'
import MainLogo from '../icons/mainLogo'
import { IStore, store } from '@src/store'
import { AppTypes } from '@src/reducers/app.reducer'
import { useSelector } from 'react-redux'
import ExpandIcon from '../icons/expand'

export const DesktopView: React.FC<AuthViewProps> = (props) => {
  const closeMenu = () => store.dispatch({ type: AppTypes.CLOSE_MENU })
  const collapsedMenu = useSelector((state: IStore) => state.app.collapsedMenu)

  const toggleMenu = () => {
    store.dispatch({ type: AppTypes.TOGGLE_MENU })
  }
  return (
    <DesktopContainer>
      <div className="flex flex-row items-center gap-18 pl-6">
        {collapsedMenu ? (
          <ExpandIcon className="text-menuLink cursor-pointer hover:text-menuLinkHover" onClick={toggleMenu} />
        ) : (
          <CollapseIcon className="text-menuLink cursor-pointer hover:text-menuLinkHover" onClick={toggleMenu} />
        )}
        <Link to="/" onClick={closeMenu}>
          <MainLogo className="w-auto" style={{ height: '34px' }} />
        </Link>
      </div>
      <WalletSection>
        <WalletComponent />
      </WalletSection>
      <RightSection>
        <ControlsGroup>
          <SearchButton />
          {props.isLoggedIn && <NotificationsControl />}
          <ChatControl />
        </ControlsGroup>
        <AuthSection {...props} />
      </RightSection>
    </DesktopContainer>
  )
}
